type ReportHandler = (metric: {
  name: string;
  value: number;
  id: string;
}) => void;

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && typeof onPerfEntry === "function") {
    import("web-vitals").then(
      ({ onCLS, onFID, onFCP, onLCP, onTTFB, onINP }) => {
        // Subscribe to the metrics
        onCLS(onPerfEntry);
        onFID(onPerfEntry);
        onFCP(onPerfEntry);
        onLCP(onPerfEntry);
        onTTFB(onPerfEntry);
        // INP (Interaction to Next Paint) is a new metric in web-vitals v4
        if (onINP) {
          onINP(onPerfEntry);
        }
      },
    );
  }
};

export default reportWebVitals;
